<template lang="html">
  <section :id="id" class="distribution-channel">
    <div class="channel-section">
      <chevrons :is-open="isOpen" @on-chevon-click="toggleIsOpen" />
      <span class="channel" @click.stop="toggleIsOpen">
        {{ distributionChannel.name }}
      </span>
    </div>
    <div class="widget-list" v-if="isOpen">
      <custom-display-element-draggable
        v-for="(widget, index) in distributionChannel.widgets"
        :key="index"
        :widget="widget"
        @on-drag-start-element="onStartDragging"
        @on-drag-end-element="onEndDragging"
      />
    </div>
  </section>
</template>

<script lang="js">
  import Chevrons from "@/views/drag-drop-pages/components/Chevrons";
  import CustomDisplayElementDraggable from "@/components/custom-display-elements/page-elements/CustomDisplayElementDraggable";

  export default  {
    name: "distribution-channel",
    components: {
      Chevrons,
      CustomDisplayElementDraggable
    },
    props: {
      id: String,
      distributionChannel: {
        type: Object,
        default: function() {
          return {};
        }
      }
    },
    data () {
      return {
        isOpen: true
      }
    },
    methods: {
      toggleIsOpen() {
        this.isOpen = !this.isOpen;
      },
      onStartDragging(ctx) {
        this.$emit("on-drag-start-widget", ctx);
      },
      onEndDragging(ctx) {
        this.$emit("on-drag-end-widget", ctx);
      }
    }
  }
</script>

<style scoped lang="scss">
  .distribution-channel {
    position: relative;
    padding: 0.5rem 0;
    .channel-section {
      display: flex;
      align-items: center;
      column-gap: 0.3rem;
      margin-bottom: 0.3rem;
      cursor: pointer;
      .channel {
        font-weight: bold;
        font-size: 0.9rem;
        color: var(--DEFAULT_TEXT_BLACK, #000000);
      }
    }
    .widget-list {
      box-sizing: border-box;
      padding-left: 0.2rem;
    }
  }
</style>
